module.exports = require("./../../_gen/openfl/text/TextLineMetrics");